export const NoteTypeConstants = {
    DISCIPLINARY: '95C05389-8597-4971-B50F-3C146D4A102F'.toLocaleLowerCase(),
    GENERAL: '25B0CAFE-57F1-4612-9E7E-417AE5496FED'.toLocaleLowerCase(),
    TODO_TASK: '0400DBF8-7D93-4D23-865A-52181AE3C59F'.toLocaleLowerCase(),
    SYSTEM_TASK: '10504F5C-8E25-4F3D-B974-7508CF3C081A'.toLocaleLowerCase(),
    INCOMPLETE_RECORD: '423F9067-B4C8-4540-9F01-89EB5612A643'.toLocaleLowerCase(),
    FLAG: '7F730FF1-EE7E-49CE-8861-BEA46E936550'.toLocaleLowerCase(),
    TAG: '8C0E6AB0-293A-46CD-A939-C2A15E497E8A'.toLocaleLowerCase(),
    IMPORTANT: 'B8A62F77-40BE-4112-A559-CF4FD11BA034'.toLocaleLowerCase(),
    TECHNICAL_ISSUE: 'ED6ADF46-AF4C-4CF1-A178-E41B28B3FDD0'.toLocaleLowerCase()
}
